import type { DeployAction } from "../types/actions";
import type { WarchestState } from "../types/game-state";
import {
  advanceActivePlayer,
  allHandsEmpty,
  moveCoin,
} from "../utils/zone-utils";

export function applyDeploy(
  state: WarchestState,
  action: DeployAction,
): WarchestState {
  const zones = moveCoin(
    state.playerZones[action.player],
    action.coinType,
    "hand",
    "discardFaceUp",
  );
  const newBoard = {
    ...state.board,
    [action.targetHex]: {
      unitType: action.coinType,
      owner: action.player,
      stackSize: 1,
    },
  };
  const newPlayerZones = { ...state.playerZones, [action.player]: zones };
  const nextActive = advanceActivePlayer(action.player, newPlayerZones);
  const nextPhase = allHandsEmpty(newPlayerZones)
    ? ("DRAW_COINS" as const)
    : state.phase;
  return {
    ...state,
    board: newBoard,
    playerZones: newPlayerZones,
    activePlayer: nextActive,
    phase: nextPhase,
    initiativeTransferredThisRound:
      nextPhase === "DRAW_COINS" ? false : state.initiativeTransferredThisRound,
    turn: nextPhase === "DRAW_COINS" ? state.turn + 1 : state.turn,
  };
}
